import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-jc-error',
  templateUrl: './jc-error.component.html',
  styleUrls: ['./jc-error.component.css']
})
export class JcErrorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
